module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av410-b154fa55e569f4792702b76a44af0ca9.jpg";